<template>
    <div class="header">
        <van-nav-bar
            safe-area-inset-top
            @click-left="onClickLeft"
        >
          <template #left v-if="this.$route.meta.iconLeft">
            <van-icon name="arrow-left" class="font" />
          </template>
          <template #right>
            <div class="station-selector-wrapper">
              <div class="current-station bck-role" :style="{width:'160px'}" @click="showRoleFlag=!showRoleFlag">
                <div class="current-station-name">{{roleName}}</div>
                <div class="current-station-icon" v-show="roleList.length>1"><van-icon name="arrow-down" color="white" /></div>
              </div>
              <div class="station-selector" v-show="showRoleFlag&&roleList.length>1">
                <div class="station-item" @click="getActiveRole(item)" v-for="(item,index) in roleList" :key="index">
                  <div class="station-info">
                    <div class="station-name">{{item}}</div>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </van-nav-bar>
    </div>
</template>
<script>
import {getLocalItem} from "@/untils/common";

export default {
    name:'',
    data(){
        return{
          siteId:'',
          roleName:'',
          showRoleFlag:false,
          roleList:['助手管理','HDMI管理']
        }
    },
    methods:{
        onClickLeft(){
            let tit = this.$route.meta.title;
            if(tit!=='首页'){
              this.$router.push({path: '/userHome',query:{openid: getLocalItem('open_id')}})
            }
        },
        // 多角色切换时
        getActiveRole(item){
            this.showRoleFlag = false;
            this.roleName = item;
            if(item==='助手管理'){
              this.$router.push({path: '/medium',query:{sid: this.siteId}})
            }
            if(item==='HDMI管理'){
              this.$router.push({path: '/hdmiMedium',query:{sid: this.siteId}})
            }
        },
    },
    created(){
      this.siteId = this.$route.query.sid;
      if(this.$route.name==='hdmiMedium'){
        this.roleName = this.roleList[1];
      }else{
        this.roleName = this.roleList[0];
      }
    }
}
</script>
<style lang="scss" scoped>
.font{
  font-size:40px
}
.van-nav-bar{
  position: fixed;
  z-index: 10;
  top: 0;
}
</style>
